import React from 'react';

const Picker = ({ onPickerClick }) => {
  return (
    <div className="pl2 pr2 center">
      <h2 className="tc">Still can't decide? I can pick one for you:</h2>
      <button
        className={`tc tracked bg-purple white bw0 br4 pa2 mt4 mb2 center db w6 mw-80 ttu`}
        onClick={onPickerClick}
      >
        Pick a random class
      </button>
    </div>
  );
};

export default Picker;
